import StdDialogActions from 'components/Dialogs/StdDialogActions';
import StdDialogContent from 'components/Dialogs/StdDialogContent';

import React from 'react';

import { useTheme } from '@mui/material/styles';

import ArrowBackIcon from '@mui/icons-material/ArrowBack';

import CloudOff from '@mui/icons-material/CloudOff';
import { Typography } from '@mui/material';
import Box from '@mui/system/Box';
import type { Institution } from 'app-components/flux/institutions/institutionsTypes';
import { tracker } from 'app-components/utils/core';
import { useEffectOnce } from 'react-use';

type FiIssueWarningProps = {
  handleTryAnywayPress: () => void;
  handleCancel: () => void;
  institution: Institution | undefined;
};

export default function FiIssueWarning({ institution, handleTryAnywayPress, handleCancel }: FiIssueWarningProps) {
  const theme = useTheme();

  const { fiIssue } = institution ?? {};

  useEffectOnce(() => {
    if (institution && fiIssue) {
      tracker.track(tracker.events.fiStatusBanner, {
        type: fiIssue.issueType,
        source: fiIssue.issueSource,
        channel: fiIssue.channel,
        location: 'addFi partner auth',
        institution_id: institution.id,
        institution_name: institution.name || 'Unknown',
        aggregator: institution.aggregator || 'Unknown',
        action: 'shown',
      });
    }
  });

  // Note - Should never happen, protecting edge case where we somehow lose the fiIssue that got us to this dialog
  if (!fiIssue) {
    handleTryAnywayPress();
    return null;
  }

  return (
    <>
      <StdDialogContent sx={{ display: 'flex', mt: 7, mx: 12, p: 0 }}>
        <Box flexDirection='column' display='flex' alignItems='center'>
          <Box flexDirection='row' display='flex' alignItems='center'>
            <CloudOff fontSize='medium' sx={{ color: theme.palette.error.main, mr: 1 }} />
            <Typography
              textAlign='center'
              variant='titleMedium'
              color={theme.palette.error.dark}
            >{`${fiIssue.shortMessage}`}</Typography>
          </Box>
          <Box flexDirection='row' display='flex' alignItems='center'>
            <Typography textAlign='center'>{`${fiIssue.longMessage}`}</Typography>
          </Box>
        </Box>
      </StdDialogContent>
      <StdDialogActions
        primary={{
          children: 'Try Anyway',
          id: 'continueButton',
          onClick: handleTryAnywayPress,
        }}
        secondary={{
          children: 'Go back',
          id: 'secondary-button',
          onClick: handleCancel,
          variant: 'text',
          startIcon: <ArrowBackIcon />,
          sx: { marginRight: 2 },
        }}
      />
    </>
  );
}
